import axios from './index'


//页面初始化
export const clfxxinit = (param) => {
  return axios.httpRequest({
    url: '/crossroad/queryRecord',
    method: 'post',
    data: param,
  })
}


